(function () {
  /* ---- Build the table of contents from the article's own headings ---- */
  var content = document.querySelector('[data-bd-article-content]');
  var tocWrap = document.querySelector('[data-bd-toc]');
  var tocList = document.querySelector('[data-bd-toc-list]');

  if (content && tocWrap && tocList) {
    /* skip headings with no visible text (e.g. an empty <h2><br></h2>) */
    var headings = Array.prototype.slice
      .call(content.querySelectorAll('h2, h3'))
      .filter(function (h) {
        return h.textContent.trim() !== '';
      });

    if (!headings.length) {
      tocWrap.hidden = true;
    } else {
      var usedIds = {};
      var links = [];
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      headings.forEach(function (h) {
        if (!h.id) {
          var slug = h.textContent
            .trim()
            .toLowerCase()
            .replace(/[^a-z0-9]+/g, '-')
            .replace(/(^-|-$)/g, '');
          if (!slug) slug = 'section';
          if (usedIds[slug]) {
            usedIds[slug]++;
            slug = slug + '-' + usedIds[slug];
          } else {
            usedIds[slug] = 1;
          }
          h.id = 'bd-toc-' + slug;
        }

        var li = document.createElement('li');
        li.className = h.tagName === 'H3' ? 'bd-toc__item bd-toc__item--sub' : 'bd-toc__item';
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        a.addEventListener('click', function (e) {
          e.preventDefault();
          h.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
          history.pushState(null, '', '#' + h.id);
          setActive(h);
        });
        li.appendChild(a);
        tocList.appendChild(li);
        links.push({ heading: h, item: li });
      });

      function setActive(heading) {
        links.forEach(function (l) {
          l.item.classList.toggle('is-active', l.heading === heading);
        });
      }

      /* Scroll-spy: the active entry is the LAST heading that has
         scrolled past the line just under the header. Works the same
         when scrolling up or down (the old observer only fired when a
         heading entered the band, so it lagged on the way back up). */
      var ticking = false;

      function updateActive() {
        ticking = false;
        var current = null;
        var line = window.innerWidth < 750 ? 90 : 120;

        for (var i = 0; i < links.length; i++) {
          if (links[i].heading.getBoundingClientRect().top <= line) {
            current = links[i].heading;
          } else {
            break;
          }
        }

        setActive(current);
      }

      function onScroll() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(updateActive);
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      updateActive();
    }
  }

  /* ---- Copy link ----
     The button says "Copy Link", so it copies. Before, any phone with the
     Web Share API (almost all of them) opened the share sheet instead and
     never showed "Copied!". Now: copy first; only fall back to the share
     sheet / legacy copy if the clipboard isn't available. */
  var copyBtn = document.querySelector('[data-bd-copy-link]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var url = copyBtn.getAttribute('data-url');
      var label = copyBtn.querySelector('[data-bd-copy-label]');

      function showCopied() {
        if (!label) return;
        var original = label.getAttribute('data-original') || label.textContent;
        label.setAttribute('data-original', original);
        label.textContent = 'Copied!';
        setTimeout(function () {
          label.textContent = original;
        }, 1800);
      }

      function legacyCopy() {
        var temp = document.createElement('input');
        temp.value = url;
        temp.setAttribute('readonly', '');
        temp.style.position = 'fixed';
        temp.style.opacity = '0';
        document.body.appendChild(temp);
        temp.select();
        temp.setSelectionRange(0, url.length);

        var ok = false;
        try {
          ok = document.execCommand('copy');
        } catch (err) {
          ok = false;
        }

        document.body.removeChild(temp);
        return ok;
      }

      function fallback() {
        if (legacyCopy()) {
          showCopied();
        } else if (navigator.share) {
          navigator.share({ url: url, title: document.title }).catch(function () {});
        }
      }

      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(url).then(showCopied).catch(fallback);
      } else {
        fallback();
      }
    });
  }
})();